import React from 'react';

export default function Dashboard() {
    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:pt-16">
           
        </div>
    );
}